import React from 'react'
import SmartImplant from '../../../../dental/mobile/LevelTwo/SmartImplant';
import image from "../../../../../assets/images/Dental/internalHexagonConnection/smartImplants/modals/Is-four-circle_mobile.png";

const IsFour = (props) => {
	return (
		<SmartImplant
			image={image}
			reference={3}
			system='internalHexagonConnection'
			isFour
		/>
	)
}

export default IsFour